import React, { ComponentType, useState } from 'react';
import { LayoutProps } from '@jsonforms/core';
import {
  JsonFormsStateContext,
  ResolvedJsonFormsDispatch,
  withJsonFormsContext,
} from '@jsonforms/react';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { startCase, isObject, cloneDeep, isEqual } from 'lodash';

interface ArrayWrapperProps extends LayoutProps {
  index: number;
  label: string;
  disabled: boolean;
  minItem?: number;
}

function overrideActionData(uiSchema: any, index: number) {
  let assertIndex: ({ key, schema }: { key: string; schema: any }) => void;

  assertIndex = ({ key, schema }: { key: string; schema: any }) => {
    if (
      ['dependencies', 'hiddenFieldPaths', 'dataPath', 'schemaScope'].includes(
        key,
      ) &&
      Array.isArray(schema[key])
    ) {
      schema[key].forEach((fieldPath: { path: string }) => {
        fieldPath.path = fieldPath.path.replace('$index', index.toString());
      });
    }
    if (key === 'removedPaths' && Array.isArray(schema[key])) {
      schema[key].forEach((removedPath: string) => {
        removedPath = removedPath.replace('$index', index.toString());
      });
    } else if (key === 'var') {
      schema[key] = schema[key].replace('$index', index.toString());
    }
    if (key === 'keyPath' || key === 'dependentPath') {
      schema[key] = schema[key].replace('$index', index);
    } else if (
      schema[key] &&
      Object.keys(schema[key]).length &&
      isObject(schema[key])
    ) {
      overrideKeyPath(schema[key]);
    }
  };

  const getActionDataPtahs = cloneDeep(uiSchema);
  const overrideKeyPath = (schema: {}) => {
    Object.keys(schema).forEach((key) => {
      assertIndex({ key, schema });
    });
  };
  overrideKeyPath(getActionDataPtahs);
  return getActionDataPtahs;
}

export const ArrayWrapper = (props: ArrayWrapperProps) => {
  const [isOpened, setIsOpened] = useState(true);
  const { uischema, schema, path, renderers, cells, label, index } = props;
  const elements = uischema.options?.['detail']['elements'];
  const itemsToRender = elements.map((element: any, i: number) => {
    element = cloneDeep(overrideActionData(element, index));
    return (
      <ResolvedJsonFormsDispatch
        schema={schema}
        uischema={element}
        path={path}
        enabled={true}
        renderers={renderers}
        cells={cells}
        key={i + path}
      />
    );
  });
  return (
    <>
      <div
        className="section-header-label"
        onClick={() => setIsOpened(!isOpened)}
      >
        <span>{startCase(label)}</span>
        <span className={`arrow `}>
          {isOpened === true ? <UpOutlined /> : <DownOutlined />}
        </span>
      </div>
      <div className={!isOpened ? 'collapsed-item' : ''} hidden={!isOpened}>
        <div>{itemsToRender}</div>
      </div>
    </>
  );
};

const   withContextToArrayWrapperRenderd =
  (
    Component: ComponentType<ArrayWrapperProps>,
  ): ComponentType<ArrayWrapperProps> =>
  ({ props }: JsonFormsStateContext & ArrayWrapperProps & LayoutProps) => {
    return <Component {...props} />;
  };

const withCustomProps = (Component: ComponentType<ArrayWrapperProps>) => {
  return withJsonFormsContext(
    withContextToArrayWrapperRenderd(
      React.memo(Component, (prevProps, props) => isEqual(prevProps, props)),
    ),
  );
};

export default withCustomProps(ArrayWrapper);
